const rawBase = import.meta.env?.VITE_API_BASE_URL;
let normalizedBase = typeof rawBase === "string" && rawBase.trim().length > 0
  ? rawBase.trim().replace(/\/+$/, "")
  : "";

// Production-safe default: if no env is set and we are on apaauto.ca, use the API host
if (!normalizedBase && typeof window !== 'undefined') {
  const h = window.location.hostname || '';
  if (h.endsWith('apaauto.ca')) {
    normalizedBase = 'https://api.apaauto.ca';
  }
}

function ensureLeadingSlash(path: string) {
  if (!path.startsWith("/")) {
    return `/${path}`;
  }
  return path;
}

export function apiUrl(path: string): string {
  const fragment = ensureLeadingSlash(path);
  if (!normalizedBase) {
    return fragment;
  }
  return `${normalizedBase}${fragment}`;
}

export function apiFetch(input: string, init?: RequestInit) {
  const opts: RequestInit = { credentials: 'include', ...(init || {}) };
  return fetch(apiUrl(input), opts);
}

export const API_BASE_URL = normalizedBase;
